import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink py-9" data-id="element-73" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-74" data-mp="3gf96f0gd6eb2">
        <p className="font-display text-base font-extrabold uppercase tracking-[0.14em] text-shell sm:text-lg" data-id="element-75" data-mp="3ggk72reij5xy">
          The Pickleball <span className="text-lime" data-id="element-76" data-mp="32m1ef7odfgsu">Instructor’s Vault™</span>
        </p>
        <p className="mt-4 font-display text-sm font-semibold uppercase tracking-[0.2em] text-shell/50" data-id="element-77" data-mp="36ppivhhphw9v">
          Play · Teach · Inspire
        </p>
        <div className="mx-auto mt-7 h-px w-16 bg-lime/60" aria-hidden="true" data-id="element-78" data-mp="3990ijjp5eap" />
        <p className="mt-7 font-sans text-xs leading-relaxed text-shell/55" data-id="element-79" data-mp="3lec9wggp4cgx">
          © 2026 The Pickleball Instructor’s Vault™ — All rights reserved.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-xs leading-relaxed text-shell/60" data-id="element-80" data-mp="3qblwlocpaa12">
          The Pickleball Instructor’s Vault™ is an educational coaching
          resource. It does not replace professional certification, coaching
          experience or individualised medical advice.
        </p>
      </div>
    </footer>;
}